module.exports = __webpack_public_path__ + "static/media/kids_31.4a6ff549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_31.jpg
// module id = 5887
// module chunks = 0